module.exports = __webpack_public_path__ + "static/media/sysedit_1.91b31354.ico";